import { useContext, useEffect, useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import ProductsPage from "./pages/ProductsPage/ProductsPage";
import Course from "./pages/CoursesPage/CoursePage";
import Test from "./pages/TestPage/Test";
import CourseDescPage from "./pages/CourseDescriptionPage/CourseDescPage";
import PaymentPage from "./pages/PaymentPage/PaymentPage";
import CallPage from "./pages/CallPage/CallPage";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import CancellationPolicy from "./pages/CancellationPolicy/CancellationPolicy";
import ContactUs from "./pages/ContactUs/ContactUs";
import ConfirmationPage from "./pages/ConfimationPage/ConfirmationPage";
import ResourcePage from "./pages/ResourcePage/ResourcePage";
import ConsultingProgramPage from "./pages/ConsultingPage/ConsultingProgramPage";
import { baseURL } from "./utility/api";
import { MainContext } from "./context/MainContext";
import axios from "axios";
import { ToastContainer } from "react-toastify";

import MyCoursesPage from "./pages/MyCoursesPage/MyCoursesPage";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import MySessionPage from "./pages/MySessionPage/MySessionPage";
import ResumeMakerPage from "./pages/ResumeServicePage/ResumeService";
import ResumeReviewPage from "./pages/ResumeReviewPage/ResumeReviewPage";
import SessionPage from "./pages/SessionPage/SessionPage";
import TestimonialPage from "./pages/TestimonialPage/TestimonialPage";
import WebinarPage from "./pages/WebinarPage/WebinarPage";
import CohortPage from "./pages/CohortPage/CohortPage";
import MockInterviewPage from "./pages/MockInterviewPage/MockInterviewPage";
import MarketingProgramPage from "./pages/MarketingFellowship/MarketingProgramPage";
import SecondCohortPage from "./pages/SecondCohort/SecondCohortPage";
import ProgramPage from "./pages/Programs/ProgramPage";
import ResumePopupSideBySide from "./components/PopUp/ResumePopupSideBySide";
import HRFellowshipPage from "./pages/HRFellowship/HRFellowshipPage";
// import ConsultingProgramPage from "./pages/ConsultingPage/ConsultingProgramPage";
import SDECohort from "./pages/SDECohortPage/SDECohort";
import NewCourseDescV2 from "./components/CourseDesc/NewCourseDescV2";
import CourseCardPage from "./pages/CourseCardPage/CourseCardPage";
import Articleship from "./pages/ArticleShip/Articleship";
import PlacementCohortPage from "./pages/PlacementCohort/PlacementCohortPage";
import CollegePage from "./pages/CollegeQuotation/CollegePage";

// Layout Component
const Layout = ({
  children,
  showFooter,
  isOpen,
  handleSubMenu,
  pageType = "default",
  showBottomNavBar = true,
}) => (
  <div className="flex flex-col min-h-screen">
    <Navbar
      isOpen={isOpen}
      handleSubMenu={handleSubMenu}
      showBottomNavBar={showBottomNavBar}
    />
    <main className="flex-grow">{children}</main>
    {showFooter && <Footer pageType={pageType} />}
  </div>
);

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const { user, setUser, isLoggedIn, setIsLoggedIn, setIsLoading } =
    useContext(MainContext);

  const getUser = async () => {
    try {
      setIsLoading(true);
      const url = `${baseURL}/login/success`;
      const response = await axios.get(url, { withCredentials: true });
      setUser(response.data.user);

      response.data.user ? setIsLoggedIn(true) : setIsLoggedIn(false);

      setIsLoading(false);
    } catch (err) {
      // Handle error
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  const handleSubMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const closeSubMenu = () => {
    if (isOpen) setIsOpen(false);
  };

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <HomePage />
            </Layout>
          }
        />
        <Route
          path="*"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <ErrorPage />
            </Layout>
          }
        />
        <Route
          path="/products"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <ProductsPage />
            </Layout>
          }
        />

        <Route
          path="/courses/:id"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <CourseDescPage />
            </Layout>
          }
        />
        <Route
          path="/courses/:id/pay"
          element={
            <Layout
              showFooter={false}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={false}
            >
              <PaymentPage />
            </Layout>
          }
        />
        <Route
          path="/courses/:id/pay"
          element={
            <Layout
              showFooter={false}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <PaymentPage />
            </Layout>
          }
        />

        <Route
          path="/session"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <SessionPage />
            </Layout>
          }
        />

        <Route
          path="/testimonial"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <TestimonialPage />
            </Layout>
          }
        />
        <Route
          path="/webinar/:id"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <WebinarPage />
            </Layout>
          }
        />
        <Route
          path="/accept-payment/:id"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <CohortPage />
            </Layout>
          }
        />

        <Route
          path="/bookcall/:id"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <CallPage />
            </Layout>
          }
        />

        <Route
          path="/bookcall/pay/:id"
          element={
            <Layout
              showFooter={false}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={false}
            >
              <PaymentPage />
            </Layout>
          }
        />
        <Route
          path="/resume-maker"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <ResumeMakerPage />
            </Layout>
          }
        />
        <Route
          path="/resume-review"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <ResumeReviewPage />
            </Layout>
          }
        />

        <Route
          path="/mock-interview"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <MockInterviewPage />
            </Layout>
          }
        />
        <Route
          path="/product/pay/:id"
          element={
            <Layout
              showFooter={false}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={false}
            >
              <PaymentPage />
            </Layout>
          }
        />
        <Route
          path="/test"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <Test />
            </Layout>
          }
        />
        <Route
          path="/terms-of-service"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <TermsAndConditions />
            </Layout>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <PrivacyPolicy />
            </Layout>
          }
        />
        <Route
          path="/cancellation-and-refund-policy"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <CancellationPolicy />
            </Layout>
          }
        />
        <Route
          path="/contactus"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <ContactUs />
            </Layout>
          }
        />
        <Route
          path="/confirmation-page/:orderId"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <ConfirmationPage />
            </Layout>
          }
        />

        {/* PROTECTED ROUTES */}
        <Route
          path="/my-courses"
          element={
            <PrivateRoute isAuthenticated={isLoggedIn}>
              <Layout
                showFooter={true}
                isOpen={isOpen}
                handleSubMenu={handleSubMenu}
              >
                <MyCoursesPage />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/my-sessions"
          element={
            <PrivateRoute isAuthenticated={isLoggedIn}>
              <Layout
                showFooter={true}
                isOpen={isOpen}
                handleSubMenu={handleSubMenu}
              >
                <MySessionPage />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/view-courses/:id"
          element={
            <PrivateRoute isAuthenticated={isLoggedIn}>
              <Layout
                showFooter={true}
                pageType="course-page"
                isOpen={isOpen}
                handleSubMenu={handleSubMenu}
              >
                <Course />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/my-resources"
          element={
            <PrivateRoute isAuthenticated={isLoggedIn}>
              <Layout
                showFooter={true}
                isOpen={isOpen}
                handleSubMenu={handleSubMenu}
              >
                <ResourcePage />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/consulting/:id"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={true}
            >
              <ConsultingProgramPage />
            </Layout>
          }
        />

        <Route
          path="/consult-page"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <PrivacyPolicy />
            </Layout>
          }
        />

        {/* <Route
          path="/marketing"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={true}
            >
              <MarketingProgramPage />
            </Layout>
          }
        /> */}

        <Route
          path="/internship-cohort"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={true}
            >
              <SecondCohortPage />
            </Layout>
          }
        />
        <Route
          path="/programs"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={true}
            >
              <ProgramPage />
            </Layout>
          }
        />

        <Route
          path="/sde-fellowship"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={true}
            >
              <SDECohort />
            </Layout>
          }
        />

        <Route
          path="/hr-fellowship"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={true}
            >
              <HRFellowshipPage />
            </Layout>
          }
        />

        <Route
          path="/all-courses"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <CourseCardPage />
            </Layout>
          }
        />

        <Route
          path="/articleship-cohort"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <Articleship />
            </Layout>
          }
        />

        <Route
          path="/placement-cohort"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
            >
              <PlacementCohortPage />
            </Layout>
          }
        />

        <Route
          path="/bring-us-to-campus"
          element={
            <Layout
              showFooter={true}
              isOpen={isOpen}
              handleSubMenu={handleSubMenu}
              showBottomNavBar={true}
            >
              <CollegePage />
            </Layout>
          }
        />
      </Routes>

      <ResumePopupSideBySide />
    </>
  );
}

export default App;
